import { useState } from 'react';
import {IMPORT_PROJECT, NOT_IMPORTABLE_REASONS_AS_EXCEPTIONS, PROJECT_ID, PROJECT_TYPE} from "../constants/constants";

export const useError = () => {
    const [errors, setError] = useState<Array<{ component: string; message: string | Array<string> }> | null>(null);

    const handleSetError = (props: { input: string, value: boolean, message?: string | Array<string> } | null) => {
        setError((prevState) => {
            if(!props) {
                return null
            }

            const { input, value, message } = props;

            const arr = prevState?.filter(({ component }) => component !== input) || [];

            if(value && message) {
                arr.push({ component: input, message })
            }

            return arr
        })
    }

    const handleGetError = (input: string): string | string[] | undefined => {
        const error = errors?.find(({ component }) => component === input);
        return error?.message;
    };

    const projectIdError = handleGetError(PROJECT_ID);
    const projectTypeError = handleGetError(PROJECT_TYPE);
    const importProjectError = handleGetError(IMPORT_PROJECT);
    const notImportableReasonsAsExceptions = handleGetError(NOT_IMPORTABLE_REASONS_AS_EXCEPTIONS);

    return {
        errors,
        handleSetError,
        handleGetError,
        projectIdError,
        projectTypeError,
        importProjectError,
        notImportableReasonsAsExceptions
    }
}